import { useQuery, useQueryClient } from "@tanstack/react-query";
import { studentCoursesApi } from "api/student-courses/studentCoursesApi";
import { QUERIES_KEYS } from "queries";

export const useStudentCourses = (studentId: string | number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.STUDENT_COURSES(Number(studentId)),
    queryFn: () => studentCoursesApi.fetch(Number(studentId)),
    enabled: !!studentId,
  });
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.STUDENT_COURSES(Number(studentId)),
    });
  };

  return { invalidate, isLoading, isFetching, courses: data?.data ?? [] };
};
